import PropTypes from 'prop-types';
import React from 'react';

import { Header } from './style';

/**
 * Small UI component aimed to cut repetition of css.
 */
const SectionHeader = ({ children, className }) => (
  <Header variant="h2" className={className}>
    {children}
  </Header>
);

SectionHeader.propTypes = {
  /** Displayed content. */
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.element,
  ]).isRequired,
  /** Css theme. */
  className: PropTypes.string,
  /** Css theme. */
  style: PropTypes.object,
};

SectionHeader.defaultProps = {
  className: '',
  style: {},
};

export default SectionHeader;
